import type { NavigateFunction } from 'react-router-dom';
import { trackSubscriptionUpgradeClick } from './posthog';

/** Navigation vers /app/subscription avec tracking intent premium. */
export function navigateToSubscription(
  navigate: NavigateFunction,
  source: string,
  properties?: Record<string, unknown>
): void {
  trackSubscriptionUpgradeClick(source, properties);
  navigate('/app/subscription');
}

/** Redirection hard (window.location) avec tracking. */
export function redirectToSubscription(source: string): void {
  trackSubscriptionUpgradeClick(source);
  window.location.href = '/app/subscription';
}
